export enum ContentBundleName {
  CIGNAACCESSREG = 'cignaaccessreg',
  CIGNAACCESS = 'cignaaccess',
  CIGNAFORBROKERS = 'cfb',
}

export interface ContentBundleManifest {
  public: {
    [lang: string]: { [bundle in ContentBundleName]: string };
  };
  customizations: {
    [brandingId: string]:
      | {
          // NOTE: bundles optional because not all bundles will be in customizations
          [lang: string]:
            | { [bundle in ContentBundleName]: string | undefined }
            | undefined;
        }
      | undefined;
  };
}
